/* eslint-disable mastery/named-colors */
/** @deprecated use `useTheme()` for colors instead */
export const deprecatedGrey = '#f0f0f0';
/** @deprecated use `useTheme()` for colors instead */
export const deprecatedMidGrey = '#dbdbdb';
